import * as tslib_1 from "tslib";
// NGRX
import { select } from '@ngrx/store';
// CRUD
import { BaseDataSource } from '../_base/crud';
import { selectVehicleTypeInStore, selectVehicleTypePageLoading, selectVehicleTypeShowInitWaitingMessage } from './vehicletype.selector';
var VehicleTypeDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(VehicleTypeDataSource, _super);
    function VehicleTypeDataSource(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.loading$ = _this.store.pipe(select(selectVehicleTypePageLoading));
        _this.isPreloadTextViewed$ = _this.store.pipe(select(selectVehicleTypeShowInitWaitingMessage));
        _this.store.pipe(select(selectVehicleTypeInStore)).subscribe(function (response) {
            _this.paginatorTotalSubject.next(response.totalCount);
            _this.entitySubject.next(response.items);
        });
        return _this;
    }
    return VehicleTypeDataSource;
}(BaseDataSource));
export { VehicleTypeDataSource };
//# sourceMappingURL=vehicletype.datasource.js.map